;(function(window, $) {
    window.ns = window.ns || {};

    window.ns['main'] = {
        init: function() {
            // main slider plugin init
            initSlider();
        }
    };

    function initSlider() {
        var $slider = $('#slider');
        if (!$slider.length) return;

        var $slideNumber = $slider.parent().find('.main-slider_nav .len .cur'),
            $activeDot;

        $slider.owlCarousel({
            items:1,
            margin:10,
            // autoHeight:true,
            autoplay: true,
            autoplayTimeout: 3000,
            loop:true,
            dots:true,
            dotsContainer:'.main-slider_dots',
            nav:true,
            navContainer:'.main-slider_nav',
            onTranslated : function(){
                $activeDot = $slider.parent().find('.main-slider_dots .owl-dot.active');
                $slideNumber.html($activeDot.index()+1);
            }
        });
    }
})(window, jQuery);